import * as React from "react";
import type { SVGProps } from "react";

interface MainProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Main = ({ cancelled = false, ...props }: MainProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(6 6.556)">
        <circle cx={26.125} cy={26.454} r={26.125} fill="#FFE42B" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="m.783 18.493.5.427c.28.241.602.542.94.883a25 25 0 0 1 3.073 3.821 29.7 29.7 0 0 1 3.278 6.686l.61 1.897c3.673 11.271 10.223 19.041 18.533 21.58q2.874.877 12.06-3.408c-.11-.772-2.668-.258-3.44-.152-10.243 1.401-18.713-6.048-23.041-19.336l-.453-1.426a34.1 34.1 0 0 0-3.934-8.192 29.3 29.3 0 0 0-3.605-4.475 22 22 0 0 0-.817-.785l-.636-.553-.246-.195C2.989 14.777.32 17.994.783 18.493M21.616.125l.21.306.141.196c.19.257.418.543.671.843 1 1.183 2.22 2.358 3.636 3.483a32.5 32.5 0 0 0 5.89 3.7l1.506.704c10.725 4.94 17.733 12.313 19.485 20.827q.66 3.201-4.483 11.694c-.752-.203-.198-2.02 0-2.774 2.675-10.167-3.703-19.62-16.353-25.59l-1.44-.664c-2.686-1.266-5.108-2.766-7.266-4.48-1.636-1.299-3.058-2.67-4.243-4.072-.627-.742-1.122-1.41-1.413-1.888-.397-.653 3.243-2.97 3.66-2.285"
        />
      </g>
      <g strokeLinejoin="round">
        <circle cx={33} cy={33.5} r={26.5} stroke="#FFF" strokeWidth={3} />
        <circle cx={33} cy={33.5} r={26} stroke="#000" strokeWidth={2} />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Main;
